<template>
  <div class="comp-banner" v-if="overlayName" :class="{ visible: showOverlay }">
    <div class="click-catcher"></div>
    <div ref="content" class="content" :class="{ 'align-top': contentAlignTop }">
      <div class="close" @click="close">
        <IconClose />
      </div>
      <template v-if="overlayName === 'cookies'">
        <h6>{{ $t('banners.cookies.title') }}</h6>
        <p v-html="$t('banners.cookies.body')"></p>
      </template>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import Store from '@/store';
  import IconClose from '@/assets/svg/icon-times.svg?inline';

  export default {
    name: 'Banner',
    components: {
      Store,
      IconClose,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        overlayName: null,
        showOverlay: false,
        contentAlignTop: false,
      };
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    filters: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      show(name) {
        this.overlayName = name;
        Vue.nextTick(() => {
          this.showOverlay = true;
          const { content } = this.$refs;
          if (content.clientHeight >= window.innerHeight) {
            this.contentAlignTop = true;
          }
        });
      },
      close() {
        Store.cookies = true;
        this.showOverlay = false;
        this.contentAlignTop = false;
        Vue.nextTick(() => {
          this.overlayName = null;
        });
      },
    },
  };
</script>

<style lang="scss">
  @import '../../assets/scss/variables';
  @import '../../assets/scss/mixins';

  .comp-banner {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2147483650; /* thanks to Drift Widget z-index bullshit */
    background: rgba(0, 0, 0, .8);
    display: inline-flex;
    justify-content: center;
    opacity: 0;
    pointer-events: none;

    @include screen-mobile {
      overflow-y: scroll;
      padding: 0;
    }

    &.visible {
      opacity: 1;
      pointer-events: all;
      transition: opacity $default-transition;
      .content {
        opacity: 1;
        transition: opacity $default-transition 0.3s;
      }
    }

    .click-catcher {
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: $color-black;
      opacity: 0;
    }

    .content {
      position: relative;
      z-index: 2;
      display: block;
      align-self: flex-end;
      background: $color-white;
      width: calc(100% - 40px);
      padding: 47px 50px 25px;
      opacity: 0;

      &.align-top {
        align-self: flex-start;
        margin-top: 50%;
      }

      @include screen-mobile {
        width: 100%;
        padding: 47px 25px 20px 25px;
      }

      h6 {
        margin: 0 0 22px;
        @include font-daimler-cs(500);
        font-size: 1.5rem;
        letter-spacing: 0.6px;
        color: $color-black;
      }

      p {
        @include font-daimler-cs(400);
        font-size: 1.5rem;
        line-height: 1.46;
        letter-spacing: 0.6px;
        color: $color-black;
      }

      .close {
        position: absolute;
        right: 28.6px;
        top: 27.5px;
        cursor: pointer;
      }
    }
  }
</style>
